export const MAX_TOOLTIP_ITEMS_LENGTH = 3;
